<template>
  <v-card color="grey lighten-4" max-width="598px" flat>
    <v-toolbar color="primary" dark dense height="30">
      <v-toolbar-title>
        <v-icon left> mdi-plus-box-outline </v-icon> Nueva Visita
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        icon
        @click="
          set_dialogNewVisit(false);
          selected = 0;
        "
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-divider></v-divider>
    <v-card-text>
      <v-col cols="12">
        <span
          v-if="!showcal"
          class="subtitle-2 font-weight-bold black--text mx-n3"
        >
          Fecha Visita: {{ moment(fechavi).format("DD/MM/YYYY") }}</span
        >
        <v-menu
          v-else
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="10"
          transition="fab-transition"
          offset-y
          min-width="200px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formatCalendarDia"
              label="Seleccione Dia "
              append-icon="mdi-calendar-today"
              readonly
              class="mt-1 font-weight-black"
              v-bind="attrs"
              v-on="on"
              hide-details
              dense
              outlined
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fecha_hoy"
            :first-day-of-week="1"
            reactive
            @input="menu2 = false"
            color="#002f6c"
            :locale="localidad"
            :min="minimo"
            :max="fecha_max"
            :landscape="landscape"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-divider></v-divider>
      <v-radio-group v-model="TipoVisita">
         <template v-slot:label>
          <strong>Atención al cliente</strong>
        </template>
      <v-radio
        v-for="item in atencioncli"
        :key="item.id"
        :label="`${item.des}`"
        :value="item.id"
      ></v-radio>
    </v-radio-group>
    
      <v-divider></v-divider>
      <v-row>
        <v-col class="d-flex mt-3" cols="12">
          <v-select
            v-model="selected"
            :items="acuerdos"
            label="Seleccione el acuerdo"
            outlined
            return-object
            hide-details
            chips
            dense
            :menu-props="{ top: false, offsetY: true }"
            :item-text="(item) => `${item.des} `"
            item-value="id"
          >
            <template #selection="{ item }">
              <v-chip color="accent mt-1 ml-n1 font-weight-bold" label>
                <v-icon left> mdi-check </v-icon>
                {{ `${item.des}` }}</v-chip
              >
            </template>
          </v-select>
        </v-col>
        <v-divider></v-divider>
        <v-col class="d-flex" cols="12" md="5">
          <v-text-field
            v-model="monto"
            label="Monto"
            append-icon="mdi-currency-usd"
            class="mt-1 font-weight-black"
            hide-details
            dense
            outlined
            :disabled="selected.id !== 3"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="7">
          <v-text-field
            v-model="refer"
            label="Referencia"
            class="mt-1 font-weight-black"
            hide-details
            dense
            outlined
            :disabled="selected.id !== 3"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <strong>Detalle de la Visita</strong>

          <v-slide-group multiple show-arrows v-model="detalleselect">
            <v-slide-item
              v-for="(item, i) in detalles"
              :key="i"
              v-slot="{ active, toggle }"
            >
              <v-btn
                class="mx-1"
                :input-value="active"
                active-class="accent"
                depressed
                small
                @click="toggle"
              >
                {{ item.des }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-col>
        <v-col cols="12" class="d-flex">
          <v-textarea outlined v-model="obs" label="Observaciones"></v-textarea>
        </v-col>
       
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :loading="loadingAgenda"
        @click="guardarAgenda"
        color="success"
        class="mr-3"
      >
        Guardar
      </v-btn>
      <v-btn
        text
        color="error"
        @click="
          selected = 0;
          set_dialogNewVisit(false);
        "
      >
        Salir
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from "moment";
export default {
  props: {
    showcal: Boolean,
    fechavi: String,
    idcli: Number,
    iddist: Number,
  },
  data() {
    return {
      row: 1,
        TipoVisita: 1,
      selected: 0,
      monto: 0,
      obs: "",
      refer: 0,
      detalleselect: [],
      model: null,
      fecha_max: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 10), //fecha dia
      fecha_hoy: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 10), //fecha dia

      menu2: false,
      acuerdos: [
        { id: 0, des: "Ninguno" },
        { id: 1, des: "Negociacion" },
        { id: 2, des: "Servicio" },
        { id: 3, des: "Cobro" },
        { id: 4, des: "Otro" },
      ],
      detalles: [
        { id: 0, des: "Pedido" },
        { id: 1, des: "Cobro" },
        { id: 2, des: "Material Publicidad" },
        { id: 3, des: "Presupuesto" },
        { id: 4, des: "Llamar despues" },
      ],
      atencioncli: [
        { id: 1, des: "Presencial" },
        { id: 2, des: "Telefonico" },
        { id: 3, des: "Email" },
   
      ],
    };
  },
  computed: {
    ...mapState("mod_agendaset", ["loadingAgenda"]),
    ...mapState("mod_agendaquery", [
      "landscape",
      "maximo",
      "minimo",
      "localidad",
    ]),

    isDetalle: function () {
      return function (id) {
        return this.detalleselect.includes(id);
      };
    },

    fechaAgenda() {
      let fecha = "";
      fecha = this.showcal ? this.fecha_hoy : this.fechavi;
      return moment(fecha).format("DD/MM/YYYY");
    },
    formatCalendarDia() {
      moment.locale("es");
      return moment(this.fecha_hoy).format("L");
    },
  },
  methods: {
    ...mapMutations("mod_agendaquery", ["clr_dsAgenda"]),
    ...mapMutations("mod_agendaset", ["set_dialogNewVisit", "set_idDialog"]),
    ...mapActions("mod_agendaset", ["visitaAgenda"]),
    ...mapActions("mod_agendaquery", ["get_dsAgenda"]),

    async setAgenda(dist, cli) {
       this.clr_dsAgenda();
      await this.get_dsAgenda({
        vendedor: dist,
        opc: 6,
        cliente: cli,
      });
    },
    async guardarAgenda() {
      await this.visitaAgenda({
        fecha: this.fechaAgenda,
        cliente: this.idcli,
        opc:2,
        vendedor: this.iddist,
        TipoVisita: this.TipoVisita,
        notas: this.obs,
        IndPedidos: this.isDetalle(0),
        IndCobros: this.isDetalle(1),
        IndBoletin: this.isDetalle(2),
        IndPresupuesto: this.isDetalle(3),
        IndCall: this.isDetalle(4),
        Acuerdos: this.selected.id,
        tipoper: 2,
      });
      await this.setAgenda(this.iddist, this.idcli);
       this.set_dialogNewVisit(false);
       this.set_idDialog();
    },
  },
};
</script>

